<template>
  <v-card height="100%">
    <div v-if="loadingFicheVisiteur" class="wz_loadingChat text-xs-center">
      <v-progress-circular :size="70" :width="1" indeterminate class="primary--text"></v-progress-circular>
    </div>
    <div v-else-if="error">
      <v-alert type="warning" value="true">
        {{ $t('queryFailed') | cap }}
      </v-alert>
    </div>
    <div v-else>
      <v-btn
        small
        flat
        color="secondary"
        to="/profile"
      >
        {{ $t('editFicheLayout') }}
        <v-icon right>list_alt</v-icon>
      </v-btn>
      <div>
        <v-list two-line dense>
          <!-- Focus -->
          <v-list-tile avatar xs12 v-show="layout[0].show">
            <v-list-tile-action>
              <v-icon>{{ layout[0].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('currentPage') | cap }}</v-list-tile-title>
              <v-list-tile-sub-title v-if="visiteurComputed.network">
                <v-icon v-if="visiteurComputed.network == 'facebook'" class="icone_facebook">mdi-facebook-box</v-icon>
                <v-icon v-else-if="visiteurComputed.network == 'whatsapp'" class="icone_whatsapp">mdi-whatsapp</v-icon>
                {{visiteurComputed.network}}
              </v-list-tile-sub-title>
              <v-list-tile-sub-title v-else>
                <a :href="refererUrl" target='_blank'>{{refererUrl}}</a>
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Motif -->
          <v-list-tile avatar xs12 v-show="layout[18].show">
            <v-list-tile-action>
              <v-icon>{{ layout[18].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('currentMotif') | cap }}</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.motifchat}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Focus Ts -->
          <v-list-tile avatar xs12 v-show="layout[1].show">
            <v-list-tile-action>
              <v-icon>{{ layout[1].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('lastLoadingDate') | cap }}</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.lastTs}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Infos Visiteur -->

          <!-- invitation à chater -->
          <v-list-tile avatar xs12 v-show="layout[2].show">
            <v-list-tile-action>
              <v-icon>{{ layout[2].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>
                {{ $t('autochatTitle') }} {{ visiteurComputed.alertsAllowed === false ? $t('disabled') : $t('enabled') }}
              </v-list-tile-title>
              <v-switch v-model="alertsVisiteur" hide-details @click="stopAlert" class="ml-1"></v-switch>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Focus -->
          <v-list-tile avatar xs12 v-show="layout[3].show">
            <v-list-tile-action>
              <v-icon>{{ layout[3].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('comment') }}</v-list-tile-title>
              <div>{{visiteurComputed.comment}}</div>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Identité -->
          <v-list-tile avatar xs12 v-show="layout[4].show">
            <v-list-tile-action>
              <v-icon>{{ layout[4].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('identity') }}</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.identity}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Email -->
          <v-list-tile avatar xs12 v-show="layout[5].show">
            <v-list-tile-action>
              <v-icon>{{ layout[5].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('email') }}</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.email}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Tel -->
          <v-list-tile avatar xs12 v-show="layout[6].show">
            <v-list-tile-action>
              <v-icon>{{ layout[6].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('phone') }}</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.tel}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Gclid -->
          <v-list-tile avatar xs12 v-show="layout[19].show" v-if="visiteurComputed.gclid">
            <v-list-tile-action>
              <v-icon>{{ layout[19].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Gclid</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.gclid}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Géoloc -->
          <v-list-tile avatar xs12 v-show="layout[7].show" v-if="!visiteurComputed.geoloc || testGeoloc">
            <v-list-tile-action>
              <v-icon>{{ layout[7].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content v-if="user.askGeoloc === '0' ">
              <v-btn v-if="visiteurComputed.socketID !== 0" color="primary" dark :loading="loadingGeoloc" @click="demandeGeoloc()">Géolocaliser</v-btn>
              <v-btn v-else-if="visiteurComputed.socketID === 0" disabled>Géolocaliser</v-btn>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile avatar xs12 v-show="layout[7].show" v-else-if="visiteurComputed.geoloc && visiteurComputed.geoloc.erreur !== '0'">
            <v-list-tile-action>
              <v-icon>{{ layout[7].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{visiteurComputed.geoloc.message}}</v-list-tile-title>
              <v-list-tile-sub-title></v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-card v-show="layout[7].show" v-else-if="visiteurComputed.geoloc && visiteurComputed.geoloc.erreur === '0'">
            <v-list-tile-content>
              <gmap-map v-if="visiteurComputed.geoloc" :center="{lat: visiteurComputed.geoloc.latitude, lng: visiteurComputed.geoloc.longitude}"
                :zoom="7" :options="{scrollwheel: false}" style="width: 100%; height: 250px">
                <gmap-marker :position="{lat: visiteurComputed.geoloc.latitude, lng: visiteurComputed.geoloc.longitude}" :clickable="false"
                  :draggable="false"></gmap-marker>
              </gmap-map>
            </v-list-tile-content>
          </v-card>

		<!-- SELLSY -->
        <v-list v-if="showSellsyIfSo && sellsyinfo2.id !== ''" two-line dense subheader>
          <v-subheader >INFO SELLSY</v-subheader>
          <!-- type -->
          <v-list-tile v-if="sellsyinfo2.type !== '' ">
            <v-list-tile-content>
              <v-list-tile-title>Type de contact</v-list-tile-title>
              <v-list-tile-sub-title>{{sellsyinfo2.type}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>          
          <!-- identité -->
          <v-list-tile v-if="sellsyinfo2.fname !== '' || sellsyinfo2.lname !== ''">
            <v-list-tile-content>
              <v-list-tile-title>Identité</v-list-tile-title>
              <v-list-tile-sub-title>{{sellsyinfo2.gender}} {{sellsyinfo2.fname}} {{sellsyinfo2.lname}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>          
          <!-- contact -->
          <v-list-tile v-if="sellsyinfo2.email !== '' || sellsyinfo2.tel !== ''">
            <v-list-tile-content>
              <v-list-tile-title>Contact</v-list-tile-title>
              <v-list-tile-sub-title>{{sellsyinfo2.email}} - {{sellsyinfo2.tel}} </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>          
          <!-- note -->
          <v-list-tile v-if="sellsyinfo2.comment !== '' ">
            <v-list-tile-content>
              <v-list-tile-title>Note</v-list-tile-title>
              <v-list-tile-sub-title>{{sellsyinfo2.comment}} </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>

          <!-- AUTRE -->
          <!-- Navigateur -->
          <v-subheader >AUTRES INFO</v-subheader>
          <v-list-tile avatar xs12 v-show="layout[8].show">
            <v-list-tile-action>
              <v-icon>{{ layout[8].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('browser') | cap }}</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.browser}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Lang -->
          <v-list-tile avatar xs12 v-show="layout[9].show">
            <v-list-tile-action>
              <v-icon>{{ layout[9].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('language') | cap }} ({{ $t('browser') }})</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.language}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- IP -->
          <v-list-tile avatar xs12 v-show="layout[10].show">
            <v-list-tile-action>
              <v-icon>{{ layout[10].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>IP</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.ip}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- infos visiteur page chatting -->
          <!-- pondération -->
          <v-list-tile
            v-if="brideMenu('stats_leads_chaleur') === '1'"
            avatar xs12 v-show="layout[11].show"
          >
            <v-list-tile-action>
              <v-icon>{{ layout[11].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('leadHeat') }}</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.ponderation}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- alertt panier -->
          <v-list-tile avatar xs12 v-show="layout[12].show">
            <v-list-tile-action>
              <v-icon>{{ layout[12].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('alertCart') | cap }}</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.numListeAlerte}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- autoinvitation -->
          <v-list-tile avatar xs12 v-show="layout[13].show">
            <v-list-tile-action>
              <v-icon>{{ layout[13].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('lastInvitAuto') | cap }}</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.lastInvitTs}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- debut de la conversation -->
          <v-list-tile avatar xs12 v-show="layout[14].show">
            <v-list-tile-action>
              <v-icon>{{ layout[14].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('beginningChat') | cap }}</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.visiteurFirstChat}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- NAVIGATION -->
          <v-list-group
            v-show="layout[15].show"
            v-model="histoUrlOpened"
            :prepend-icon="layout[15].icon"
            no-action
            @click="histoUrlCharged && histoUrlOpened
              ? fermeHistoUrl()
              : histoUrlCharged && !histoUrlOpened
                ? ouvreHistoUrl()
                : showNav()"
            :append-icon="histoUrlCharged && histoUrlOpened
              ? 'zoom_out'
              : histoUrlCharged && !histoUrlOpened
                ? 'zoom_in'
                : 'zoom_in'"
          >
            <v-list-tile slot="activator">
              <v-list-tile-content>
                <v-list-tile-title>
                  <v-progress-circular :size="24" v-if="loadingHistoUrl" indeterminate color="primary"></v-progress-circular>
                  <span v-else>{{ $t('navigationHistory') }}</span>
                </v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <!-- URLs -->
            <template v-for="(url,j) in listUrls">
              <v-list-tile ripple :key="j">
                <v-list-tile-content>
                  <v-list-tile-title>
                    <a :href="url.url" target="_blank">{{url.smallurl}}</a> ({{ $tc('times', url.nb, { count: url.nb }) }})
                  </v-list-tile-title>
                  <v-list-tile-sub-title>
                    {{ url.last }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              
            </template>
          </v-list-group>

          <!-- ECOMMERCE -->
          <!-- achat -->
          <v-list-tile avatar xs12 v-show="layout[16].show">
            <v-list-tile-action>
              <v-icon>{{ layout[16].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $tc('purchases', 2, { count: '' }) | cap }}</v-list-tile-title>
              <v-list-tile-sub-title>{{ visiteurComputed.purchases }}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- panier -->
          <v-list-tile avatar xs12 v-show="layout[17].show">
            <v-list-tile-action>
              <v-icon>{{ layout[17].icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ $t('lastKnownBasket') }}</v-list-tile-title>
              <v-list-tile-sub-title>
                {{ visiteurComputed.last_cart_date }} {{ visiteurComputed.last_cart_amount }} {{ visiteurComputed.last_cart_nb }}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <!-- GETPLUS -->
        <v-list v-if="visiteurComputed.getplus && visiteurComputed.getplus !== ''" two-line dense subheader>
          <v-subheader v-if="visiteurComputed.getplus && visiteurComputed.getplus !== ''">INFO GETPLUS</v-subheader>
          <v-subheader v-else-if="visiteurComputed.apiinfo && visiteurComputed.apiinfo !== ''">INFO API</v-subheader>
          <!-- raison social -->
          <v-list-tile v-if="visiteurComputed.getplus['raison sociale'] && visiteurComputed.getplus['raison sociale'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>Raison Sociale</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.getplus["raison sociale"]}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- email -->
          <v-list-tile v-if="visiteurComputed.getplus['email'] && visiteurComputed.getplus['email'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>email</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.getplus["email"]}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- segment -->
          <v-list-tile v-if="visiteurComputed.getplus['segment'] && visiteurComputed.getplus['segment'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>Segment</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.getplus["segment"]}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- naf -->
          <v-list-tile v-if="visiteurComputed.getplus['code NAF'] && visiteurComputed.getplus['code NAF'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>code NAF</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.getplus["code NAF"]}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Activité -->
          <v-list-tile v-if="visiteurComputed.getplus['activité'] && visiteurComputed.getplus['activité'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>Activité</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.getplus["activité"]}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- adresse -->
          <v-list-tile v-if="visiteurComputed.getplus['adresse'] && visiteurComputed.getplus['adresse'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>adresse</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.getplus["adresse"]}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Téléphone -->
          <v-list-tile v-if="visiteurComputed.getplus['telephone'] && visiteurComputed.getplus['telephone'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>Téléphone</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.getplus["telephone"]}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- dirigeant -->
          <v-list-tile v-if="visiteurComputed.getplus['dirigeant'] && visiteurComputed.getplus['dirigeant'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>dirigeant</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.getplus["dirigeant"]}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Effectif -->
          <v-list-tile v-if="visiteurComputed.getplus['effectif'] && visiteurComputed.getplus['effectif'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>Effectif</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.getplus["effectif"]}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- CA -->
          <v-list-tile v-if="visiteurComputed.getplus['CA'] && visiteurComputed.getplus['CA'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>CA</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.getplus["CA"]}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Segment -->
          <v-list-tile v-if="visiteurComputed.getplus['segment'] && visiteurComputed.getplus['segment'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>Segment</v-list-tile-title>
              <v-list-tile-sub-title>{{visiteurComputed.getplus["segment"]}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
          <!-- Siret - siren -->
          <v-list-tile v-if="visiteurComputed.getplus['siret'] && visiteurComputed.getplus['siret'] !== ''">
            <v-list-tile-content>
              <v-list-tile-title>Siret - siren</v-list-tile-title>
              <v-list-tile-sub-title>
                {{visiteurComputed.getplus["siret"]}} {{visiteurComputed.getplus["siren"]}}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
        <!-- INFOS API -->
        <v-list v-else-if="visiteurComputed.apiinfo && visiteurComputed.apiinfo !== ''" two-line dense>
          <div v-for="(inf, j) in visiteurComputed.apiinfo" :key="j">
            <v-list-tile>
              <v-list-tile-content>
                <v-list-tile-title>{{ j }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ inf }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </div>
        </v-list>
      </div>
    </div>
  </v-card>
</template>

<style>
.wz_loadingChat{
  top: calc(50% - 35px);
  position: relative;
}
.list__tile {
  user-select: auto !important;
}
</style>

<script>
import Vue from 'vue'
import {mapGetters, mapState, mapMutations} from 'vuex'
import * as VueGoogleMaps from 'vue2-google-maps'
import moment from 'moment'
import _ from 'lodash'
import _watcheebox from '../watcheebox/watcheebox.js'
import { FORM_LAYOUT } from '../../constants.js'

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCc2X0qGdzjlu6eyh1xQZdgAL5AHOJ818M'
    // key: 'AIzaSyB6HdsrSEfX2rNTjcWWnv-9PXgE2U0x11M' // targetfirst
  }
})
export default {
  data () {
    return {
      error: false,
      loadingFicheVisiteur: false,
      loadingHistoUrl: false,
      histoUrlCharged: false,
      histoUrlOpened: false,
      infoStatus: true,
      visiteurInfo: {},
      listUrls: null,
      navComputed: false,
      alertsVisiteur: this.datasVisiteur.alertsAllowed,
      // datasVisiteur : this.returnInfosVisiteur,
      loadingGeoloc: false,
      dataWatchVisteur: {},
      /**
       * Disposition de la fiche
       */
      showLayoutChooser: false,
      showSellsyIfSo: false,
      layout: [],
      sellsyinfo2: { id: '' }
    }
  },

  props: ['datasVisiteur'],

  watch: {
    'datasVisiteur': function (val, oldval) {
      if (!val) {
        this.dataWatchVisteur = oldval
      } else {
        this.dataWatchVisteur = val
      }
    },
    'datasVisiteur.visiteurID': function (val, oldval) {
      this.fermeMAJHistourl() // referme l'historique de navigation
      this.showInfo(this.datasVisiteur)
    }
  },

  methods: {
    ...mapMutations('_StoreWatcheeBox', [
      'SET_VISITEURS',
      'SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE',
      'SET_CONTACT_ALL_DATA'
    ]),
    // ---------------------------------------------
    // pour tester si autorisé à afficher
    // ---------------------------------------------
    brideMenu (nameBride) {
      if (this.brides) {
        let index = this.brides.findIndex(bride => bride.brideName === nameBride)
        // console.log('index', index)
        if (index !== -1) {
          return this.brides[index].status
        }
      }
    },
    // ----------------------------------------------------------------------------
    // affiche les info
    // ----------------------------------------------------------------------------
    showInfo (_visRef) {
      let dataToGet = new window.FormData()
      dataToGet.append('session', _visRef.visiteurID)
      dataToGet.append('siteID', _visRef.siteID)
      dataToGet.append('specialtable', this.user.licSpecialtable)
      this.axios.post('get/visitor_info.php', dataToGet, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        console.log('infoVisiteur', response)
        let _identity = response.data.defaultId
        if (typeof response.data.fname !== 'undefined' && response.data.fname !== '') {
          _identity = response.data.fname
        }
        if (typeof response.data.lname !== 'undefined' && response.data.lname !== '') {
          _identity += ' ' + response.data.lname
        }
        if (_identity === response.data.defaultId) {
          if (typeof response.data.form_fname !== 'undefined' && response.data.form_fname !== '') {
            _identity = response.data.form_fname
          }
          if (typeof response.data.form_lname !== 'undefined' && response.data.form_lname !== '') {
            _identity += ' ' + response.data.form_lname
          }
        }
        let _getplus = ''
        if (typeof response.data.getplus !== 'undefined' && response.data.getplus !== '') {
          _getplus = response.data.getplus
        }
        let _apiinfo = ''
        if (typeof response.data.apiinfo !== 'undefined' && response.data.apiinfo !== '') {
          _apiinfo = response.data.apiinfo
        }
        let _email = response.data.email
        if ((!_email || _email === '') && typeof response.data.form_email !== 'undefined' && response.data.form_email !== '') {
          _email = response.data.form_email
        }
        let _tel = response.data.tel
        if ((!_tel || _tel === '') && typeof response.data.form_tel !== 'undefined' && response.data.form_tel !== '') {
          _tel = response.data.form_tel
        }
        let _comment = response.data.comment
        if ((!_comment || _comment === '') && typeof response.data.form_question !== 'undefined' && response.data.form_question !== '') {
          _comment = response.data.form_question
        }
        this.visiteurInfo = {
          session_id: response.data.session_id,
          focus: response.data.focus,
          lastTs: moment(response.data.lastTs).fromNow(),
          defaultId: response.data.defaultId,
          language: response.data.language,
          ip: response.data.ip,
          browser: response.data.browser,
          purchases: response.data.purchases,
          key: response.data.key,
          getplus: _getplus,
          apiinfo: _apiinfo,
          identity: _identity,
          fname: response.data.fname,
          lname: response.data.lname,
          date_lead: response.data.date_lead,
          email: _email,
          tel: _tel,
          comment: _comment,
          last_cart_date: response.data.last_cart_date,
          last_cart_amount: response.data.last_cart_amount,
          last_cart_nb: response.data.last_cart_nb,
          motifchat: response.data.motifchat,
          gclid: response.data.gclid
        }
        this.error = false
        // uniquement pour les messages en attentes
        if (this.$route.fullPath === '/trafic/attente' || this.directChat) {
          this.updateAllDataVisiteurOpened(this.visiteurInfo)
        // uniquement pour les contact
        } else if (this.$route.fullPath === '/trafic/contact') {
          this.updateAllDataContactOpened(this.visiteurInfo)
        }
      })
      .catch(() => {
        this.error = true
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('error'),
          context: 'error'
        })
      })
      .then(() => {
        this.loadingFicheVisiteur = false
        this.checkSellsyContact()
      })
    },
    showNav () {
      // console.log('showNav', this.visiteurComputed.visiteurID)
      this.loadingHistoUrl = true
      let dataToGet = new window.FormData()
      dataToGet.append('session', this.datasVisiteur.visiteurID)
      dataToGet.append('siteID', this.datasVisiteur.siteID)
      dataToGet.append('key', this.datasVisiteur.key)
      // console.log(this.datasVisiteur)
      this.axios.post('get/visitor_urlList.php', dataToGet, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
      .then(response => {
        this.listUrls = response.data
        this.listUrls = _.sortBy(this.listUrls, ['last']).reverse()
        this.listUrls = this.listUrls.map(url => {
          let u = url
          u.last = moment.unix(u.last).format('llll')
          return u
        })
        this.navComputed = true
        this.loadingHistoUrl = false
        this.histoUrlCharged = true
        this.histoUrlOpened = true
      })
      .catch()
    },
    // ferme l'hitorique de navigation et force le rechargement à la prochaine ouverture
    fermeMAJHistourl () {
      this.listUrls = []
      this.navComputed = false
      this.histoUrlCharged = false
      this.histoUrlOpened = false
    },
    // ferme l'hitorique de navigation uniquement
    fermeHistoUrl () {
      this.histoUrlOpened = false
      this.navComputed = false
    },

    ouvreHistoUrl () {
      this.histoUrlOpened = true
      this.navComputed = true
    },

    // -------------------------------------------------------------
    // demande de géolocalisation
    // -------------------------------------------------------------
    demandeGeoloc () {
      // check que le socket existe avant de demander
      if (!this.$socket) {
        setTimeout(() => {
          this.demandeGeoloc()
        }, 5000)
        return
      }
      // envoi au serveur la demande de géoloc
      _watcheebox.demandeGeoloc({
        'mySocketID': this.mySocketID,
        'datasVisiteur': this.datasVisiteur
      })
      this.loadingGeoloc = true
    },

    // -------------------------------------------------------------
    // stop/active les alerts du visiteur
    // -------------------------------------------------------------
    stopAlert () {
      var file = 'stop_alert.php'
      if (!this.alertsVisiteur) {
        file = 'start_alert.php'
      }
      var config = {
        responseType: 'json',
        headers: {'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded'}
      }
      // ##############################
      // Evois en POST
      // ##############################
      let dataToPost = new window.FormData()

      dataToPost.append('visiteurID', this.datasVisiteur.visiteurID)
      this.axios.post('post/' + file, dataToPost, config)
      .then(response => {
        // console.log(response)
        let newDataVisiteur = _.cloneDeep(this.datasVisiteur)
        if (this.alertsVisiteur) {
          // this.alertsVisiteur = false
          // passer le visiteur de la liste des filtrés
          // à la liste des non filtrés
          // this.datasFilterVisiteursArray[indexVisiteur].nb_alert = 0
          newDataVisiteur.nb_alert = 0
        } else {
          // this.alertsVisiteur = true
          // passer le visiteur de la liste des non filtrés
          // à la liste des filtrés
          // this.datasFilterVisiteursArray[indexVisiteur].nb_alert = 1
          newDataVisiteur.nb_alert = 1
        }
        newDataVisiteur.alertsAllowed = this.alertsVisiteur
        this.SET_VISITEURS(newDataVisiteur)
      })
      .catch()
      .then(_ => {
        // this.loading = false
      })
    },
    /**
     * Met à jour le layout de la fiche visiteur
     */
    updateFormLayout () {
      let layoutFromCookie = JSON.parse(this.$cookie.get('wz-fiche-visiteur'))
      this.layout = layoutFromCookie
        ? Object.assign(FORM_LAYOUT, layoutFromCookie)
        : FORM_LAYOUT
    },
    // -------------------------------------------------------------------
    // enregistre les données de la fichie visiteur ouverte dans attente
    // -------------------------------------------------------------------
    updateAllDataVisiteurOpened (dataVisiteur) {
      // console.log('updateAllDataVisiteurOpened', dataVisiteur)
      let visOfflineClone = _.cloneDeep(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened)
      // mise à jour de l'email si necessaire
      if (dataVisiteur.email) {
        visOfflineClone.email = dataVisiteur.email
      } else {
        visOfflineClone.email = ''
      }
      // mise à jour du tel si necessaire
      if (dataVisiteur.tel) {
        visOfflineClone.tel = dataVisiteur.tel
      } else {
        visOfflineClone.tel = ''
      }
      // mise à jour du focus si necessaire
      if (dataVisiteur.focus) {
        visOfflineClone.focus = dataVisiteur.focus
      } else {
        visOfflineClone.focus = ''
      }
      // dataVisiteur.histoChat = this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.histoChat
      this.SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE(visOfflineClone)
    },

    // -------------------------------------------------------------------
    // enregistre les données de la fichie visiteur ouverte dans contact
    // -------------------------------------------------------------------
    updateAllDataContactOpened (dataVisiteur) {
      // console.log('updateAllDataContactOpened', dataVisiteur)
      let visOfflineClone = _.cloneDeep(this.$store.state._StoreWatcheeBox.contactOpened)
      // mise à jour de l'email si necessaire
      if (dataVisiteur.email) {
        visOfflineClone.email = dataVisiteur.email
      }
      // mise à jour du tel si necessaire
      if (dataVisiteur.tel) {
        visOfflineClone.tel = dataVisiteur.tel
      }
      // mise à jour du focus si necessaire
      if (dataVisiteur.focus) {
        visOfflineClone.focus = dataVisiteur.focus
      }
      this.SET_CONTACT_ALL_DATA(visOfflineClone)
    },
    checkSellsyContact () {
      if (!this.visiteurInfo || this.visiteurInfo.email === '' || this.visiteurInfo.email === 'undefined' || typeof (this.visiteurInfo.email) === 'undefined') {
        return
      }
      if (this.$store.state._User.entSY === '1') {
        /* this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Checking Sellsy...',
          context: 'info'
        }) */
        this.sellsyinfo2 = { id: '' }

        let dataToPost = new window.FormData()
        dataToPost.append('lead', JSON.stringify(this.visiteurInfo))
        this.axios
        .post('get/lead_check_sellsy.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          if (response.data !== -1) {
            for (let i in response.data.response.result) {
              let sellsydate = response.data.response.result[i]
              this.sellsyinfo2.id = sellsydate.id
              this.sellsyinfo2.email = sellsydate.email
              this.sellsyinfo2.tel = sellsydate.formatted_tel.replaceAll(' ', '')
              this.sellsyinfo2.gender = sellsydate.civil.replaceAll('man', 'M').replaceAll('woman', 'Mme')
              this.sellsyinfo2.fname = sellsydate.forename
              this.sellsyinfo2.lname = sellsydate.name
              this.sellsyinfo2.comment = sellsydate.stickyNote
              this.sellsyinfo2.type = sellsydate.linkedtype
            }
            this.showSellsyIfSo = true
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: 'Contact identifié dans Sellsy',
              context: 'success'
            })
          } else {
            this.showSellsyIfSo = false
            /* this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: 'Pas de contact dans Sellsy',
              context: 'error'
            }) */
          }
        })
        .catch(_ => {
        })
      }
    }
  },

  created () {
    this.updateFormLayout()
  },

  mounted () {
    this.loadingFicheVisiteur = true
    this.showInfo(this.datasVisiteur)
    if (this.user.askGeoloc === '1') {
      this.demandeGeoloc()
    }
  },

  computed: {
    ...mapGetters('_User', ['user', 'brides']),
    ...mapState('_User', ['brides']),
    ...mapGetters('_Sites', ['GET_SITE_BY_ID']),
    ...mapState('_StoreWatcheeBox', ['listeAllVisiteurs', 'mySocketID']),

    // affiche la page actuelle
    refererUrl () {
      var url = null
      var index = _.findIndex(this.listeAllVisiteurs, {'visiteurID': this.visiteurComputed.visiteurID})
      if (index !== -1 && this.listeAllVisiteurs[index].pagesFocus) {
        url = this.listeAllVisiteurs[index].pagesFocus
      } else {
        url = this.visiteurInfo.focus
      }
      if (!url || url === '') {
        if (this.GET_SITE_BY_ID(this.datasVisiteur.siteID)) {
          url = this.GET_SITE_BY_ID(this.datasVisiteur.siteID).LIC_URL
        }
      }
      return url
    },
    testGeoloc () {
      return _.isEmpty(this.visiteurComputed.geoloc)
    },
    visiteurComputed () {
      return _.merge(this.visiteurInfo, this.dataWatchVisteur)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/watcheebox/WzFicheInfosVisiteur.vue